import { render, staticRenderFns } from "./settingMenuPanel.vue?vue&type=template&id=558f79d0&lang=pug"
import script from "./settingMenuPanel.vue?vue&type=script&lang=js"
export * from "./settingMenuPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports